import { Injectable, NgModuleFactoryLoader } from '@angular/core';
import { ActivatedRouteSnapshot, ActivatedRoute, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DeviceDetectorService } from 'ngx-device-detector';

import { Globals } from '@app/service/globals.service';
import { AuthService } from '@app/service/auth.service';
import { MemberService } from '@app/service/member.service';
import { UtilService } from '@app/service/util.service';

@Injectable()
export class AuthGuard implements CanActivate {

  public redirectURL: string = '';

  constructor(
    private router: Router,
    private globals: Globals,
    private member: MemberService,
    private toastrService: ToastrService,
    private readonly loader: NgModuleFactoryLoader,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private deviceService: DeviceDetectorService
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    this.redirectURL = state.url;

    let mode = ( this.redirectURL.indexOf('/admin') > -1 ) ? 'admin' : 'shop';

    return this.member.getMemberInfo( mode ).then( response => {
      if( response['ResultCode'] == true ) {
        if( mode == 'shop' ) this.authService.login( response );
        return true;

      } else {
        this.toastrService.error(response['ResultMessage'], '');

        if( mode == 'admin' )
          this.router.navigate(
            ['/admin/login'],
            {
              queryParams: {},
              relativeTo: this.activatedRoute,
              queryParamsHandling: '', // remove to replace all query params by provided
            }
          );
        else {
          if( this.deviceService.isMobile() )
            this.router.navigate(['/mobile/login']);
          else
            this.router.navigate(['/member/login']);
        }

        return false;
      }
    })
    .catch(response => {
      return false;
    });
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.canActivate(next, state);
  }
}